export const logLevels = {
  trace: "trace",
  debug: "debug",
  info: "info",
  warning: "warning",
  error: "error",
  fatal: "fatal",
};